import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImageButtonComponent } from './image-button.component';

@NgModule({
    declarations: [ ImageButtonComponent ],
    imports: [
        CommonModule
    ],
    exports: [ ImageButtonComponent ]
})
export class ImageButtonModule {
}
